import React, { useState, useReducer, useEffect, useCallback } from 'react';
import siteReducer from '../../reducers/siteDetails';
import SiteMap from '../common/SiteMap';
import ScrollView from 'devextreme-react/scroll-view';
import Button from 'devextreme-react/button';
import { Link, Redirect } from 'react-router-dom';
import "../../styles/scss/cluster.scss";
import * as actions from '../../actions/siteDetails';
import * as utils from '../../common/utils';
import SelectBox from '../common/selectBox/SelectBox';
import * as actionsCluster from '../../actions/cluster';
import { Toast } from 'devextreme-react/toast';
import { confirm, alert } from 'devextreme/ui/dialog';

const initialState = { siteLocations: [], locationList: [] };

export default (props) => {
    const { category, data, selectedClusterName, uniqueClusterNames } = props;
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { siteLocations, locationList } = state;
    const [zoomMarker, setZoomMarker] = useState(null);
    const [zoomSiteInfo, setZoomSiteInfo] = useState(null);
    const [showCluster, setShowCluster] = useState(true);
    const [activeTier, setActiveTier] = useState('4');
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });
    const initialClusterDetails = { clusterName: "", siteid: "", sbgid: "", siteUid: "", iscluster: "true", isactive: "true" }
    const [clusterName, setClusterName] = useState(selectedClusterName)
    const [clustersData, setClusterData] = useState([...data])
    const [isEditOn, setIsEditOn] = useState(true)
    const [filteredSites, setFilteredSites] = useState([])
    const [searchText, setSearchText] = useState("")
    const [scrollConfig] = useState({ showScrollbar: 'always', scrollByContent: true, scrollByThumb: true });

    const upIcon = <i className="fa fa-sort-up fa-lg" style={{ "marginTop": "10px" }}></i>;
    const downIcon = <i className="fa fa-sort-down fa-lg" ></i>;

    let tierList = utils.TIER_LIST

    useEffect(() => {
        if (!data.length > 0) {
            setIsEditOn(false)
        }
    }, [])

    useEffect(() => {
        actions.fetchSiteLocations(dispatch, category + '&tier=' + activeTier);
    }, [activeTier])

    useEffect(() => {
        setFilteredSites([...locationList])
    }, [locationList])

    //handling activeTier state
    const onTierChange = val => {
        setActiveTier(val.id);
    }

    //map data
    function getMapData() {
        let mapData = [];
        if (filteredSites && filteredSites.length > 0) {
            mapData = filteredSites.filter(ele => clustersData.findIndex(record => record.siteid === ele.siteId) !== -1).map(data => {
                return { latLng: { lat: data.siteLatitude, lng: data.siteLongitude }, title: data.siteName, siteId: data.siteId, deployStatus: data.deployStatus }
            }
            )
        }
        return mapData;
    }

    //switching Edit
    const handleisEditOn = () => {
        setIsEditOn(cur => !cur)
    }

    // clusterName state handling
    const handleNameChange = (e) => {
        setClusterName(e.target.value.toLowerCase())
    }

    //create cluster
    const handleCreate = () => {
        let trimmedClusterName = clusterName.trim()
        if (trimmedClusterName && clustersData.length > 0) {
            if (!uniqueClusterNames.includes(trimmedClusterName)) {
                let _clusterData = clustersData.map(ele => { return { ...ele, clusterName: trimmedClusterName } })
                setClusterData([..._clusterData])
                actionsCluster.addUserCluster(dispatch, _clusterData)
                setIsEditOn(true)
                setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Cluster Creation Successful' });
                setTimeout(() => handleReload(), 1000)
            } else {
                alert("Cluster with same name already exist", "Alert")
            }
        }
        else {
            alert("Cluster Name cannot be blank and pinned sites should be atleast 1", "Alert")
        }
    }

    // cluster update
    const handleUpdate = () => {
        let trimmedClusterName = clusterName.trim() // trimming cluster name 
        if (trimmedClusterName) {
            if (trimmedClusterName === selectedClusterName) {  // if no changes with cluster name
                actionsCluster.deleteUserCluster(dispatch, data)
                let _clustersDataNew = clustersData.filter(ele => !ele.id).map(ele => { return { ...ele, clusterName: trimmedClusterName } })
                let _clustersDataExisting = clustersData.map(ele => ({ ...ele })).filter(ele => ele.id)
                _clustersDataExisting.forEach(ele => delete ele.id)
                actionsCluster.addUserCluster(dispatch, [..._clustersDataExisting, ..._clustersDataNew])
                setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Cluster Update Successful' });
                setTimeout(() => handleReload(), 1000)
            } else { // if changes with clustername
                let result = confirm("Cluster Name Changed, Do you wish to continue?", "Confirm changes");
                result.then((res) => {
                    if (res) {
                        actionsCluster.deleteUserCluster(dispatch, data)
                        let _clusterData = clustersData.map(ele => ({ ...ele, clusterName: trimmedClusterName }))
                        _clusterData.forEach(ele => delete ele.id)
                        actionsCluster.addUserCluster(dispatch, [..._clusterData])
                        setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Cluster Update Successful' });
                        setTimeout(() => handleReload(), 1000)
                    } else {
                        alert("Cluster Update Cancelled", "Alert")
                    }
                })
            }
        }
        else {
            alert("Cluster Name cannot be blank", "Alert")
        }
    }

    // cancel opeartion
    const handleCancel = () => {
        if (selectedClusterName) {
            setClusterData(data)
            setClusterName(selectedClusterName)
            setIsEditOn(true)
        }
        else {
            handleReload()
        }
    }

    //delete cluster
    const handleDelete = () => {
        let result = confirm("Do you want to delete Cluster?", "Confirm changes");
        result.then((res) => {
            if (res) {
                actionsCluster.deleteUserCluster(dispatch, data)
                setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Cluster Delete Successful' });
                setTimeout(() => handleReload(), 1000)
            } else {
                alert("Cluster Delete Cancelled", "Alert")
            }
        })
    }

    //add pinned site
    const handleAddPinSite = (site) => {
        if (!isEditOn) {
            let _newClusterRecord = { ...initialClusterDetails, siteid: site.siteId, sbgid: site.sbgId, siteUid: site.siteUId }
            setClusterData([...clustersData, { ..._newClusterRecord }])
        } else {
            alert("Click On Edit to update cluster", "Alert")
        }
    }

    //remove pinned site
    const handleRemovePinSite = (site) => {
        if (!isEditOn) {
            let _clusterData = clustersData.filter(ele => ele.siteid !== site.siteId)
            setClusterData([..._clusterData])
        } else {
            alert("Click On Edit to update cluster", "Alert")
        }
    }

    //side effect for search site
    useEffect(() => {
        if (searchText) {
            let _sites = locationList.filter(site => (site.siteId + " " + site.siteName).toLowerCase().includes(searchText.toLowerCase()))
            setFilteredSites([..._sites])
        } else {
            setFilteredSites([...locationList])
        }
    }, [searchText])

    //search site
    const handleSearchSite = (e) => {
        setSearchText(e.target.value)
    }

    //reload window
    const handleReload = () => {
        document.location.reload()
    }

    return (
        <>
            <section className="page-content ">
                <div className="map">
                    {<SiteMap markersData={getMapData()} zoomMarker={zoomMarker} sbg={category} zoomSiteInfo={zoomSiteInfo} />}
                </div>
                <div style={{ position: "fixed", top: "10%", right: "5%", display: "flex", gap: "1rem" }}>
                    {isEditOn
                        ?
                        <Button text="EDIT" onClick={handleisEditOn} />
                        :
                        <>
                            {/*<Button text="SAVE" onClick={handleSave} />*/}
                            {
                                selectedClusterName
                                    ?
                                    <>
                                        <Button text="UPDATE" onClick={handleUpdate} />
                                        <Button text="DELETE" onClick={handleDelete} />
                                    </>
                                    :
                                    <>
                                        <Button text="CREATE" onClick={handleCreate} />
                                    </>
                            }
                            <Button text="CANCEL" onClick={handleCancel} />
                        </>
                    }
                    <Button text="BACK" onClick={handleReload} />
                </div>
                <div className={showCluster ? 'site-list' : 'site-list-closed'}>
                    <div className="site-head">

                        <div className="page-heading">
                            <h3> {!showCluster ? 'Cluster details' : ''} </h3>
                        </div>

                        <div className="show-site-btn" onClick={() => setShowCluster(!showCluster)}>{showCluster ? upIcon : downIcon}</div>
                    </div>
                    {showCluster &&
                        <>
                            <div className="site-head">
                                {isEditOn
                                    ?
                                    <div className="page-heading">

                                        <h2><span className='icon customize-icon'></span> {clusterName ? clusterName : "Type Cluster Name"} </h2>
                                        {/*<h2><span><i className="icon-small icon-pinned"></i></span> {clusterName ? clusterName : "Type Cluster Name"} </h2>*/}
                                    </div>
                                    :
                                    <div className="search" >
                                        <div className="form-group" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                            <input type="text" placeholder="Type Cluster Name" value={clusterName} onChange={handleNameChange} disabled={isEditOn} />
                                        </div>
                                    </div>
                                }
                                <div className="dx-field" style={{ "marginBottom": "0px" }}>
                                    <div className="dx-field-value">
                                        <span className="tier-container"><SelectBox items={tierList} value={activeTier} handleChange={onTierChange} /></span>
                                    </div>
                                </div>
                                <div className="search">
                                    <div className="form-group">
                                        <input type="text" placeholder="Search Sites" value={searchText} onChange={handleSearchSite} />
                                        <span className="icon search-icon" ></span>
                                    </div>
                                </div>
                            </div>

                            <div className="site-body" >
                                <ScrollView
                                    id="scrollview"
                                    {...scrollConfig}
                                >
                                    <div className="site-body">
                                        {
                                            filteredSites.filter(ele => clustersData.findIndex(record => record.siteid === ele.siteId) !== -1).length > 0
                                                ?
                                                filteredSites.filter(ele => clustersData.findIndex(record => record.siteid === ele.siteId) !== -1).map((site, index) => (
                                                    <div key={index} className="sites" style={{ display: "flex", gap: "1rem" }}>
                                                        <Link to={'/sitehome/' + category + '/' + site.siteId}>
                                                            <h4>{site.siteName}</h4>
                                                            <h4>({site.siteId})</h4>
                                                            <p>{site.siteAddress}</p>
                                                        </Link>
                                                        <span
                                                            className="site-zoom-map"
                                                            onClick={() => { handleRemovePinSite(site) }}
                                                        >
                                                            <i className="icon icon-pinned"></i>
                                                        </span>
                                                    </div>
                                                ))
                                                :
                                                <div className="page-heading" style={{ width: "100%", textAlign: "center", padding: '1rem' }}>
                                                    <h4>No Pinned Sites </h4>
                                                </div>
                                        }
                                        {
                                            !isEditOn
                                            &&
                                            filteredSites.filter(ele => clustersData.findIndex(record => record.siteid === ele.siteId) === -1).map((site, index) => (
                                                <div key={index} className="sites" style={{ display: "flex", gap: "1rem" }}>
                                                    <Link to={'/sitehome/' + category + '/' + site.siteId}>
                                                        <h4>{site.siteName}</h4>
                                                        <h4>({site.siteId})</h4>
                                                        <p>{site.siteAddress}</p>
                                                    </Link>
                                                    <span
                                                        className="site-zoom-map"
                                                        onClick={() => { handleAddPinSite(site) }}
                                                    >
                                                        <i className="icon icon-pinned-line"></i>
                                                    </span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </ScrollView >
                            </div>
                        </>
                    }
                </div>
            </section>
            <Toast
                visible={toastConfig.isVisible}
                message={toastConfig.message}
                type={toastConfig.type}
                onHiding={() => setToastConfig({
                    ...toastConfig,
                    isVisible: false,
                })}
                displayTime={2000}
            />
        </>
    );
}